import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const RecordingsListPage = lazy(() => import('./RecordingsListPage'));
const RecordingDetailPage = lazy(() => import('./RecordingDetailPage'));
const RecordingConfigPage = lazy(() => import('./RecordingConfigPage'));

export const recordingRoutes: RouteObject[] = [
  {
    path: 'recordings',
    element: (
      <ProtectedRoute action="recordings:view">
        <RecordingsListPage />
      </ProtectedRoute>
    ),
  },
  {
    // BEFORE the `:id` route — a sibling dynamic segment would otherwise
    // swallow `config` and render the detail page for a recording named
    // "config" (the static-segment-ordering trap the route-path tests guard
    // against on the server side).
    path: 'recordings/config',
    // FIX(admin-perms-recordings): this page is `/api/admin/params` +
    // `/api/admin/transcription/health` — `params.manage`, which maps to
    // `recordings:retention`. Before: `recordings:view` (meetings.view), which
    // both let in people the page then 403s and kept out those it serves.
    element: (
      <ProtectedRoute action="recordings:retention">
        <RecordingConfigPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'recordings/:id',
    element: (
      <ProtectedRoute action="recordings:view">
        <RecordingDetailPage />
      </ProtectedRoute>
    ),
  },
];
